import { render, staticRenderFns } from "./SquareButton.vue?vue&type=template&id=8d343e0a&scoped=true&"
import script from "./SquareButton.vue?vue&type=script&lang=js&"
export * from "./SquareButton.vue?vue&type=script&lang=js&"
import style0 from "./SquareButton.vue?vue&type=style&index=0&id=8d343e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d343e0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
